import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { StartEditingCellParams } from "@ag-grid-community/core";
import { GridApi } from "@ag-grid-community/core";
import { Injectable, OnDestroy } from "@angular/core";
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';
import { AuthService } from 'src/app/services/auth.service';
import { SavePoPlanPayload } from "src/app/models/purchasing.model";
import { saveAs } from "file-saver";
import { HeaderService } from "src/app/components/header/header.service";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { EditActiveRequestModel } from "src/app/models/inventory.model";
import { InventoryService } from "src/app/services/inventory.service";
import { ReplaySubject, Subject } from "rxjs";
import { filter,takeUntil } from "rxjs/operators";
import { LoginModel } from "../models/login.model";
import { CommonService } from "../services/common.service";
import { SettingsService } from "../services/settings.service";
import { BulkDialogComponent } from "../components/bulk-dialog/bulk-dialog.component";
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { PurchasingService } from "../modules/planyard/purchasing.service";
import { ShipyardService } from "./../modules/shipyard/shipyard.service";
import { ConfirmDialogComponent } from "../components/dialogs/confirm-dialog/confirm-dialog.component";
import { ProductDetailComponent } from "./../modules/detail/product-detail/product-detail.component";
import { PriceyardService } from "../modules/priceyard/services/priceyard.service";
import { EditWarehouseComponent } from "../modules/settings/edit-warehouse/edit-warehouse.component";
import { UpgradeFeemiumDialogComponent } from "../modules/shipyard/upgrade-feemium-dialog/upgrade-feemium-dialog.component";
import { AddVendorDialogComponent } from "./../modules/inventory/vendors/add-vendor-dialog/add-vendor-dialog.component";
import { PopupLocationSummeryComponent } from "../modules/logistic/custome-component/popup-location-summery/popup-location-summery.component";
import { GridApiService } from "./grid-api.service";
import { BulkImportComponent } from "./bulk-import/bulk-import.component";
import { MixpanelService } from "../services/mixpanel.service";
import { LogisticService } from "../modules/logistic/logistic.service";
import { PopupLogisticWhLocationComponent } from "../modules/shared/popup-logistic-wh-location/popup-logistic-wh-location.component";
import { WalmartService } from "../services/walmart.service";
import { ReportsService } from "../services/reports.service";
import { ImportSingleSkuComponent } from "../modules/planyard/import-single-sku/import-single-sku.component";
import { UpdateRepricerComponent } from "../components/dialogs/update-repricer/update-repricer.component";
import { AddSkuDialogComponent } from "../components/dialogs/add-sku-dialog/add-sku-dialog.component";
import { Model } from "../models/priceyard.model";
import { PublishListingComponent } from "../components/publish-listing/publish-listing.component";
import { GridReadyEvent } from "@ag-grid-community/core";
import { VendorTogglePopupComponent } from "../modules/inventory/vendor-toggle-popup/vendor-toggle-popup.component";
import { MultipleOpenCaseDialogComponent } from "../components/dialogs/multiple-open-case-dialog/multiple-open-case-dialog.component";
import { AssignTagsComponent } from "../components/assign-tags/assign-tags.component";
import { RemoveTagsComponent } from "../components/remove-tags/remove-tags.component";
import { DeductViaSkuDialogComponent } from "../components/deduct-via-sku-dialog/deduct-via-sku-dialog.component";

import { ShipmentMonitorService } from "../services/shipment-monitor.service";

import { PublishListingWalmartComponent } from "../components/publish-listing-walmart/publish-listing-walmart.component";
import { CreateQuickProductDialogComponent } from "../components/dialogs/create-quick-product-dialog/create-quick-product-dialog.component";


@Injectable({
  providedIn: "root",
})
export class GridActionsService implements  OnDestroy  {
  gridOptions;
  gridApi: GridApi;
  currentPaneSetting = "";
  skuPane: "multiPane" | "singlePane";
  selectedRows = [];
  selectedFilters;
  printer;
  account;
  selectedClaimResponse:any;
  selectedTab:any;
  isReset: boolean = false;
  selectedStatuses = [];
  allStatus = [];
  isWalmart:boolean = false;
  globalSkuSearch$: Subject<string> = new Subject();
  updateRemainigDays$: Subject<any> = new Subject();
  dateFilter$: Subject<any> = new Subject();
  selectedColumnMap: { name: string; columnIndex: number }[];
  selectedColumnCount: number;
  globalSearch: string;
  isResetFiltered: boolean = false;
  isOpened: boolean = false;
  changedEvent$: Subject<string> = new Subject();
  changedHeader$: Subject<boolean> = new Subject();
  skuList = [];
  skuArray = [];
  categoryList$: ReplaySubject<[string]> = new ReplaySubject(1);
  rowsSelected: any;
  subGridCellFocusedIndex: number;
  userInfo: LoginModel;
  showNotification: boolean = false;
  selectedService;
  accountType: any;
  private destroy$ = new Subject<void>();
  dateFilter:any
  productGroupbyFilter:string="Date";
  settlementOrderId:any;
  exportSkusIds:any[] = [];
  accountName:string;
  snackBarPopup;
  isMinMaxUpdate: boolean = true;
  constructor(
    private priceyardService: PriceyardService,
    private gridApiService: GridApiService,
    private inventoryService: InventoryService,
    private shipyardService: ShipyardService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private headerService: HeaderService,
    private purchasingService: PurchasingService,
    private router: Router,
    private commonService: CommonService,
    private authService: AuthService,
    private planyardService: PlanyardService,
    private mixpanelService: MixpanelService,
    private logisticService: LogisticService,
    private walmartService: WalmartService,
    private reportsService:ReportsService,
    private shipmentMonitorService:ShipmentMonitorService
  ) {
    this.gridApiService.gridApi$.pipe(takeUntil(this.destroy$)).subscribe((e:GridReadyEvent) => {
      this.gridOptions = e;
      this.gridApi = e.api;
      this.gridApiService.selectedRows$.next([]);
    });

    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.account = e;
      const accountString = JSON.parse(localStorage.getItem(
        StorageKeyEnum.SelectedAccount)
      );
      this.gridApi?.deselectAll();
      this.shipyardService.shipmentTypeToAddToShipment$.next(undefined);
      if (this.shipyardService.skusToAddToShipment.length) {
        this.shipyardService.skusToAddToShipment = [];
      }
      this.commonService
        .Getcategorylist({ account: this.account[0] }).pipe(takeUntil(this.destroy$))
        .subscribe((res: any) => {
          this.categoryList$.next(res.map((category) => category.value));
        });
      if(this.account[0] && this.account[0] !== accountString) this.gridApi?.refreshServerSide({ route: [], purge: true });
    });

    this.headerService.accountSelectedType
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        if (e) {
          this.accountType = e[0];
          this.isWalmart = e[0] === "Walmart";
          this.selectedService = this.accountType === "Walmart" ? this.walmartService : this.shipyardService;
        }
      });

    this.gridApiService.selectedRows$.pipe(takeUntil(this.destroy$)).subscribe((selectedRows) => {
      this.selectedRows = selectedRows;
    });
    this.globalSkuSearch$.pipe(takeUntil(this.destroy$)).subscribe((e: string) => (this.globalSearch = e));

    this.authService.userInfo$.pipe(takeUntil(this.destroy$)).subscribe((userInfo) => {
      this.userInfo = userInfo;
    });
    this.gridApiService.showNotification$.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      this.showNotification = res;
    })
    this.dateFilter$.pipe(takeUntil(this.destroy$)).subscribe((res)=>this.dateFilter=res);

    this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy$),
    filter((e) => e.action === "PrintSkuLabelByUser"))
    .subscribe((e) => {
      const index= this.shipyardService.printSkuEventIds.findIndex(res=>res.id == e.id && !res.isShipmentSkus);
      if (e.response && e.response?.responseType == "success" && index !== -1) {
        this.snackBarPopup = this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 1000000,
            horizontalPosition: 'center',
            data: {
              title: 'Preparing for printing sku labels...',
              action: 'Dismiss',
              type: 'info',
            },
          }
        );
        this.shipyardService.printSkuEventIds.splice(index,1);
        this.shipyardService.skusToAddToShipment= [];
        this.gridApi.deselectAll();
       this.gridApi?.refreshServerSide({ purge: true });
       this.printLabel({body:e.response.message}, "SkuLabel",true);
       } else if(e.response && e.response?.responseType == "error" && index !== -1){
        this.shipyardService.printSkuEventIds.splice(index,1);
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: e.response?.message, 
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
    });
    this.setRecalCulateSignalR()

    this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy$),
    filter((e) => e.action === "FeesCalculation" && this.isMinMaxUpdate))
    .subscribe((e) => {
      if(e.response.responseType.toLowerCase() == 'success'){
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 5000,
          horizontalPosition: "center",
          data: {
            title: "Operation Successfull",
            action: "Dismiss",
            type: "success",
          },
        })
      } else if (e.response.responseType.toLowerCase() === "error") {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: e.response.message,
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }

  editNote(event): void {
    const data = event.data;
    const payload={
      note:data.Note,
      sku:[data.Sku],
      account:data.Account,
      fulfillmentType: data.FulfillmentType.toLowerCase() == "fba" ? "Fba" : "Fbm"
    }
    this.priceyardService
      .EditNote(payload).
      pipe(takeUntil(this.destroy$)).subscribe();
  }

  editCaseQty(event,column): void {
    this.skuList = [];
    const data = event.data;
    if(column === "CaseQty"){
      const skus = {
        sku: data["Sku"],
        caseQty: Number(data[column]),
        account: this.account[0],
        accountSkuId:data.AccountSkuId,
        fulfillmentType: "Fba",
        changingFactors: [],
        otherChanges: [
          {
            doubleValue: 0,
            intValue: Number(data[column]),
            name: "BoxQty",
          },
        ],
      };
      this.skuList.push(skus);
    } else if(column=="PrepCost"){
      const payload = {
        sku: data["Sku"],
        account: this.account[0],
        changingFactors: [
        {value:Number(data[column]), factor: "Prep Cost"}]
      };
      this.skuList.push(payload);
     }
    else {
      const payload = {
        sku: data["Sku"],
        account: this.account[0],
        otherChanges: [{
          name: column,
          intValue: Number(data[column]),
        }]
      };
      this.skuList.push(payload);     
    }    
    this.priceyardService.changePriceFactor(this.skuList).pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 9000,
          horizontalPosition: 'center',
          data: {
            title: 'Changes saved',
            action: 'Dismiss',
              type: 'success',
          },
        }
    );
    });
  }

  saveMinPrice(event) {
    const data = event.data;
    this.priceyardService
      .ChangeMinPrice(
        data.Sku,
        data.Account,
        data.Minpr.price,
        data.FulfillmentType
      ).pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  saveMaxPrice(event) {
    const data = event.data;
    this.priceyardService
      .ChangeMaxPrice(
        data.Sku,
        data.Account,
        data.Maxpr.price,
        data.FulfillmentType
      ).pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  saveCost(event) {
    const data = event.data;
    this.priceyardService
      .ChangeCost(data.Sku, data.Account, data.Cost, data.FulfillmentType).pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  updateSkuPricingModel(event) {
    const data = event.data;

    this.priceyardService
      .UpdateSkuPricingModel([data.Sku], data.Account, data.Prmodel)
      .pipe(takeUntil(this.destroy$)).subscribe(() =>
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Changes Saved Successfully',
              action: 'Dismiss',
              type: 'success',
            },
          })
      );
  }

  columnVisible(e: any,isGridReady = false) {
    let colID;
    if (e.visible === false) {
      colID =
        e.column?.colId == 0
          ? ""
          : e.column?.colDef.headerName
          ? e.column?.colDef.headerName
          : e.column?.colDef.field;
          if(this.showNotification){
            let snackBarRef = this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: `${colID} column was hidden`,
                  action: 'Undo',
                  type: 'success',
                },
              });
            snackBarRef.onAction()
            .pipe(takeUntil(this.destroy$)).subscribe(() =>
            this.gridApi.setColumnsVisible([e.column.colId], true)
          );
        } 
    }
  setTimeout(()=>{
    this.saveColumnState(null,isGridReady);
    if(!e.column?.colDef?.required){
      this.gridApi.refreshServerSide();
    }
  },1000)
    this.showNotification = false;
  }

  getGridColumnState(){
    this.commonService.GetApiJsonAll().pipe(takeUntil(this.destroy$)).subscribe((state: any) => {
      if (state) {
        state.forEach((res)=> {
          let jsonResponse = JSON.parse(res.apiJson)
          localStorage.setItem(res.apiName, JSON.stringify(jsonResponse));
        });      
      }
    })
  } 

  saveColumnState(e?, isGridReady = false): void {
    let storageKey
    if(e?.columnApi){
     storageKey = this.currentSubGridKey();
    }else{
     storageKey = this.currentOpenGridKey();
    }
    if (this.gridOptions) {
      if (!this.isReset) this.gridApiService.changedColumnState$.next(true); 
      if(isGridReady && storageKey){          
        let columnState = e?.columnApi ? e.columnApi.getColumnState() : this.gridOptions.columnApi.getColumnState()
        localStorage.setItem(storageKey,JSON.stringify(e?.columnApi ? e.columnApi.getColumnState() : this.gridApi.getColumnState()));
        this.saveColumnStateWithJson(storageKey,columnState);
      } 
    }
    this.isReset = false;
  }

  saveColumnStateWithJson(storageKey,columnState){
    const saveJsonPaylod= {
      apiJson: JSON.stringify(columnState),
      apiName: storageKey
    }
    this.commonService.saveApiJson(saveJsonPaylod).pipe(takeUntil(this.destroy$)).subscribe();
  }

  currentOpenGridKey(): string {
    let key = '';
    const selectedAccountType = JSON.parse(localStorage.getItem("SelectedAccountType"));
    if (this.router.url.includes('/forecasting/purchase-orders/detail/')) {
        return StorageKeyEnum.AgGridPurchaseOrderDetailGrid;
    }
    switch (this.router.url) {
    case '/inventory/skus':
      key = selectedAccountType  && selectedAccountType == 'Walmart' ? StorageKeyEnum.AgGridInventorySkusWalmart : StorageKeyEnum.AgGridInventorySkus;
      break;
    case '/shipyard/replenish':
      key = selectedAccountType  && selectedAccountType == 'Walmart' ? StorageKeyEnum.AgGridPlanyardReplenishWalmart : StorageKeyEnum.AgGridPlanyardReplenish;
      break; 
    case '/inventory/products':
      key = StorageKeyEnum.AgGridInventoryProducts;
      break;
    case '/inventory/items':
      key = StorageKeyEnum.AgGridInventoryItems;
      break;
    case '/inventory/vendors':
      key = StorageKeyEnum.AgGridInventoryVendors;
      break;
    case '/forecasting/purchasing':
      key = StorageKeyEnum.AgGridPlanyardPurchasing;
      break;
    case '/forecasting/purchasing-by-sku':
        key = StorageKeyEnum.AgGridPurchasingBySku;
        break;
    case '/forecasting/fbm-orders/orders':
          key = StorageKeyEnum.AgGridFbmOrders;
        break;
    case '/priceyard/pricing-list':
      key = StorageKeyEnum.AgGridPriceyard;
      break;
    case '/priceyard/history':
      key = StorageKeyEnum.AgGridPriceyardHistory;
      break;
    case '/priceyard/sellers':
      key = StorageKeyEnum.AgGridPriceyardSellers;
      break;
    case '/forecasting/orders':
      key = StorageKeyEnum.AgGridPlanyardOrders;
      break;
      case '/logistic/wh-location':
      key = StorageKeyEnum.AgGridWhLocation;
      break;
    case '/logistic/history':
      key = StorageKeyEnum.AgGridWhHistory;
      break;
    case '/analytics/profit-by-date':
      key = StorageKeyEnum.AgGridAnalyticsDate;
      break;
    case '/analytics/profit-by-sku':
      key = StorageKeyEnum.AgGridAnalyticsSku;
      break;
    case '/analytics/cost-details':
      key = StorageKeyEnum.AgGridCostDetails;
      break;
    case '/analytics/stock-holding':       
      key = StorageKeyEnum.AgGridStockHolding;
      break;
      case '/analytics/sales':       
      key = StorageKeyEnum.AgGridKpiSales;
       break;
      case '/analytics/profit':       
      key = StorageKeyEnum.AgGridKpiProfit;
       break;
      case '/analytics/roi':       
      key = StorageKeyEnum.AgGridKpiRoi;
       break;
      case '/analytics/stock%20holding':       
      key = StorageKeyEnum.AgGridKpiStockHolding;
       break;
      case '/analytics/overstocked':       
      key = StorageKeyEnum.AgGridKpiOverStocked;
       break;
      case '/analytics/PpcSpent':
      key = StorageKeyEnum.AgGridKpiPpcSpent;
       break;
      case '/analytics/restock%20now':
      key = StorageKeyEnum.AgGridKpiRestockNow;
       break;
      case "/analytics/out%20of%20stock":
      key = StorageKeyEnum.AgGridOutOfStock;
       break;
      case "/analytics/inventory-summary":
      key = StorageKeyEnum.AgGridInventorySummary;
       break;
      case "/analytics/po-summary":
      key = StorageKeyEnum.AgGridPoSummary;
       break;
    default:
      break;
      
    }
    return key;
  }

  applycolumnState(e?,isMasterSubGrid?) {
    let storageKey
    if(e?.columnApi && isMasterSubGrid){
      storageKey = this.currentSubGridKey();
     }else{
      storageKey = this.currentOpenGridKey();
     }
    if (this.gridOptions) {
      const state = JSON.parse(
        localStorage.getItem(storageKey)
      );
      if (state) {
        e = e || this.gridOptions;
          e.api?.applyColumnState({  
            state: state,
            applyOrder: true,
      });
            const columnStates = state;
         if(typeof(columnStates) != 'object')

            columnStates?.forEach((colState: any) => {
                if (colState.width !== undefined) {
                    e.columnApi?.setColumnWidth(colState.colId, colState.width);
                }
            });
        }
    }
  }

  currentSubGridKey(){
    if(this.router.url == '/forecasting/purchasing'){
     return StorageKeyEnum.AgGridPurchasingSubGrid;
    }
  }

  updateSelectedRows(e?) {
    if (e?.node.selected) {
      if (this.isOpened) {
        this.gridApiService.selectedRows$.next(e.data);
      }
    }
  }

  updateSelectedFilters(page?) {
    this.selectedFilters = this.gridApi.getFilterModel();
    let count = 0;
    for (let key in this.selectedFilters) {
      ++count;
    }
    if (count == 1 && this.selectedFilters["Active"]?.value == true)
      this.isResetFiltered = false;
    else if (page == "products" && count == 0) this.isResetFiltered = false;
    else this.isResetFiltered = true;
  }

  getSelected(): any[] {
    const selectedNodes = this.gridApi.getSelectedNodes();
    const data = selectedNodes.map((node) => {
      return node.data;
    });
    return data;
  }

  toggleActivate(isActive) {
    const selectedRows = this.getSelected();
    const data: EditActiveRequestModel = {
      account: this.account[0],
      active: isActive,
      accountSkuId: [],
      fulfillmentType:this.accountType != 'Amazon' ? '' : selectedRows[0].FulfillmentType,
    };

    data.accountSkuId = selectedRows.map((data) => {
      return data.AccountSkuId;
    });

    const commaSeparatedString = selectedRows
    .map(item => item.Sku)
    .join(', ');

    this.dialog
    .open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: isActive ? "Activate Skus" : "Deactivate Skus",
        message: `Are you sure you want to ${isActive ? ' activate' : ' deactivate'} skus?<br> ${commaSeparatedString}`,
        actions: [
          { text: "Cancel", buttonStyle: "underline" },
          { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
        ],
      },
    })
    .afterClosed()
    .pipe(filter((e) => e === "Confirm"))
    .subscribe((e) => {
      this.inventoryService.EditActiveById(data).pipe(takeUntil(this.destroy$)).subscribe(() => {
        const idsToUpdate = this.gridApi.getSelectedNodes().map(function (node) {
          return node.id;
        });
  
        this.gridApi.forEachNode((rowNode) => {
          if (idsToUpdate.indexOf(rowNode.id) >= 0) {
            const updated = JSON.parse(JSON.stringify(rowNode.data));
            updated.Active = isActive;
            rowNode.setData(updated);
            this.gridApi.refreshCells({
              force: true,
              columns: ["Sku"],
              rowNodes: [rowNode],
            });
          }
        });
        this.shipyardService.skusToAddToShipment= [];
        this.gridApi.deselectAll();
        this.gridApi?.refreshServerSide({ purge: true });
      });
    }); 
  }

  resetTable(columnDef?) {
    let storageKey
    this.isReset = true;
    storageKey = this.currentOpenGridKey();
    localStorage.removeItem(storageKey);
    this.gridApi.resetColumnState();
    const columnState = this.gridOptions.columnApi.getColumnState();
      columnState?.forEach(column => {
        if (column.sort) {
          column.sort = null; 
        }
      });
      this.gridOptions.columnApi.applyColumnState({ state: columnState });
    this.gridApi.setGridOption('columnDefs', columnDef);
    this.gridApi.sizeColumnsToFit();
    this.saveColumnState(null,true);
  }

  resetFilters() {
    this.gridApi.setFilterModel(null);
  }

  editCell(params: StartEditingCellParams) {
    this.gridApi.startEditingCell(params);
  }

  createShipment(withQueue=false) {
      this.createDraft(withQueue);
  }

  createShipmentForNonShipyard(){
    if(this.shipyardService.skusToAddToShipment.length !==0 && !this.shipyardService.skusToAddToShipment.filter((res)=>res.qty==0).length)
    this.router.navigate(["shipyard/sku-list"])
    else
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: 'Please select the quantity for each item',
          action: 'Dismiss',
          type: 'error',
        },
      }
    ); 
  }

  createDraft(withQueue=false) {
    if(withQueue){
      //const navigationExtras: NavigationExtras = { state: { withQueue: true } };          
          this.router.navigate([this.accountType === "Walmart" ? "shipyard/create-walmart-shipments" : "shipyard/create-shipments"]);
          this.clearQueuedSkus(); 
    } else {
      this.router.navigate([this.accountType === "Walmart" ? "shipyard/create-walmart-shipments" : "shipyard/create-shipments"]);
    }
    this.mixpanelService.track('Created Premium Shipment');
   }


  upgradeToPremium() {
    this.dialog
      .open(UpgradeFeemiumDialogComponent, {
        width: "500px",
      })
      .afterClosed()
      .pipe(filter((e) => e === "Continue"))
      .subscribe(() => {
        this.createDraft();
      });
  }

  createNewWarehouse(type) {
    this.dialog
      .open(EditWarehouseComponent, {
        width: "600px",
        height: "auto",
        maxHeight: "80%",
        maxWidth: "92vw",
        panelClass: "edit_warehouse",
        data: { ...{ type } },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((e) => {
        if (e) this.createDraft();
      });
  }

  printFNSKU(isClearQueue=false) {
    const skus = this.shipyardService.skusToAddToShipment.map((data) => {
      const selectedQty = data.qty;
      if(this.accountType == 'Amazon'){
        return {
          accountSkuId: data.sku.AccountSkuId,
          qty: selectedQty || 1,
        };
      }else{
        return {
          sku: data.sku.Sku,
          qty: selectedQty || 1,
        };
      }
    });

    const data = {
      skus: skus,
      account: this.account[0],
    };
    const totalqty=skus.reduce((sum, current) => sum + current.qty, 0);
    if(skus.length <= 50 && totalqty <=2000 ){
      return this.selectedService.PrintSku(data).pipe(takeUntil(this.destroy$)).subscribe(
        (value: any) => {
          if(isClearQueue) {
            this.clearQueuedSkus();
          }
          this.shipyardService.skusToAddToShipment= [];
          this.gridApi.deselectAll();
         this.gridApi?.refreshServerSide({ purge: true });
          this.printLabel(value, "SkuLabel");
        },
        (err) =>{
          const errorJson:any = this.shipyardService.blobToString(err.error);
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 5000,
            horizontalPosition: "center",
            data: {
              title: errorJson?.error?.length ? errorJson.error[0] : "Error printing labels",
              action: "Dismiss",
              type: "error",
            },
          })
        }
      );
    } else{
      return this.selectedService.PrintSkuSp(data).pipe(takeUntil(this.destroy$)).subscribe(
        (res: any) => {
          this.shipyardService.printSkuEventIds.push({id:res.id});
        },
        (err) =>
          this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 5000,
            horizontalPosition: 'center',
            data: {
              title: 'Error printing labels',
              action: 'Dismiss',
              type: 'error',
            },
          })
      );
    }
   
  }

  printLabel(printObject, downloadName?: string,isBlob?) {
    switch (this.printer.printer) {
      case "Preview in browser":
        if(isBlob){
          window.open(printObject.body, "_blank");
          this.showToaster(this.snackBarPopup);
        }else{
          window.open(URL.createObjectURL(printObject.body), "_blank");
        };
        break;
      case "Save as pdf":
        if(isBlob){
          this.downloadBlobType(printObject.body,downloadName,this.snackBarPopup);
        }else{
          saveAs(printObject.body, `${downloadName}.pdf`);
        }
        break;
      default:
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 5000,
          horizontalPosition: "center",
          data: {
            title: "Labels printed successfully",
            action: "Dismiss",
            type: "success",
          },
        });
    }
  }

  importFromAmazon() {
    this.priceyardService
      .DownloadSkus(this.account)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {});
  }

  ImportSingleSKU(){
    this.dialog
      .open(ImportSingleSkuComponent, {
        width: "473px",
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {
        
      });
  }

  importPrices(isPriceSettings?) {
    this.dialog
      .open(BulkImportComponent, {
        disableClose: true,
        width: "1100px",
        data:{
          isPriceSettings :isPriceSettings
        }
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {
        this.gridApi.refreshServerSide({ route: [], purge: true });
      });
  }

  onCellKeyDown(e) {
    const keyPressed = e.event.key;
    if (keyPressed === "Escape") {
      this.gridApi?.deselectAll();
      this.shipyardService.shipmentTypeToAddToShipment$.next(undefined);
      if (this.shipyardService.skusToAddToShipment.length) {
        this.shipyardService.skusToAddToShipment = [];
      }
    } else if (
      e.column &&
      (e.column.colId === "AmountInShipment" || e.column.colId === "Restock" || e.column.colId === "ReplenishByCase")
    ) {
      if (keyPressed === "ArrowDown") {
        this.shipyardService.cellFocusedIndex = e.rowIndex + 1;
      }
      if (keyPressed === "ArrowUp") {
        this.shipyardService.cellFocusedIndex = e.rowIndex - 1;
      }
    }
  }

  onSubGridCellKeyDown(e) {
    const keyPressed = e.event.key;
    if (e.column && e.column.colId === "SuggestedQty") {
      if (keyPressed === "ArrowDown") {
        this.subGridCellFocusedIndex = e.rowIndex + 1;
      }
      if (keyPressed === "ArrowUp") {
        this.subGridCellFocusedIndex = e.rowIndex - 1;
      }
    }
  }

  deselectRow(data: any) {
    if (this.gridApi?.getSelectedNodes()) {
      const row = this.gridApi
        .getSelectedNodes()
        .filter((node: any) => node.data.Sku === data.sku.Sku);
     if (row.length != 0){
      row[0].setSelected(false);
      // this.gridApi.deselectNode(row[0].rowIndex);
     } 
    }
  }

  exportSkus(page, isFiltered?,sortModel?,date?) {
    let columnsDef = this.gridApi.getColumnDefs();
    let filterModel :any= {};
    let isExport = false;
    let search = "";
    let snackbar;
    if (isFiltered) {
      search = this.globalSearch;
      filterModel = this.gridApi.getFilterModel();
      isExport = false;
      columnsDef =  columnsDef.filter((ele:any)=>!ele.hide)
    }else{
      isExport = true;
    }
    if(page === "items" || page === "vendors" || page === "profitByDate"
     || page === "profitBySkus" || page === "orders" || page === 'KPIs-sales' || page === 'poSummary' || page === 'inventory-Summary' || page === 'Stock-holding' || page === 'shipment-list'){
      snackbar = this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 1000000,
          horizontalPosition: 'center',
          data: {
            title: 'Preparing file for export...',
            action: 'Dismiss',
            type: 'info',
          },
        }
      );
    }
    if (page === "items") {
      this.priceyardService
        .GetItemListExport(filterModel, columnsDef, search,isExport)
        .pipe(takeUntil(this.destroy$)).subscribe((e) => {
          this.downloadBlob(e.body, snackbar, "item-list-download.csv");
        });
    } else if(page === "vendors"){
      this.inventoryService.ExportVendorList().pipe(takeUntil(this.destroy$)).subscribe((e)=>{
        this.downloadBlob(e.body, snackbar, "vendors-list-download.csv")
      })
    } else if(page==="profitByDate") { 
      this.reportsService
        .byDateExport(filterModel, columnsDef, search,isExport)
        .pipe(takeUntil(this.destroy$)).subscribe((e) => {
          this.downloadBlob(e.body, snackbar, "profit-by-date-download.csv");
        });
    }
    else if(page==="profitBySkus"){ 
      this.exportBySku(filterModel,columnsDef,search,snackbar,true,sortModel);
    }else if(page === 'po-summary'){
     this.exportByVendor(filterModel,columnsDef,search,snackbar);
    }else if(page === 'inventory-summary'){
      this.exportByItemInventory(filterModel,columnsDef,search,snackbar);
    }else if(page==="orders"){ 
      this.exportOrders(filterModel,columnsDef,search,snackbar,isExport);
    } 
    else if(page==="profitByProduct"|| page == 'KPIs-sales'){ 
      this.exportByProduct(filterModel,columnsDef,search,snackbar,page,sortModel,date,isExport);
    }
    else if(page==="logistic" || page == "products-Inventory") { 
      this.logisticService.ExportProductInventory().pipe(takeUntil(this.destroy$)).subscribe((e)=>{
      this.downloadBlob(e.body, snackbar, "product-inventory-download.csv");
    })
  } else if(page==="history"){ 
    this.historyExport(filterModel,columnsDef,search,snackbar,isExport);
  } else if(page==='sales-trends'){
    this.exportTrendBySku(filterModel,columnsDef,search,snackbar);  
  }else if(page === 'products'){
    if(filterModel?.Tags){
        this.setTagFilter(filterModel);
      }
    this.exportProductList(filterModel,columnsDef,search,snackbar,isExport)
  }else if(page === 'Stock-holding'){
    this.exportByStockHolding(filterModel,columnsDef,search,snackbar,true,sortModel);
  }else if(page === 'shipment-list' && !this.isWalmart){
    this.exportShipmentList(filterModel,columnsDef,search,snackbar,isExport)
  }else if(page === 'shipment-list' && this.isWalmart){
    this.exportWalmartShipmentList(filterModel,columnsDef,search,snackbar,isExport)
  } else if(page === 'claim-Center'){
    this.exportClaims(filterModel,columnsDef,search,snackbar);
  } else {
    if(filterModel?.Tags){
      this.setTagFilter(filterModel);
    }
      this.priceyardService
      .GetSimpleListExportBackground(filterModel, columnsDef, search, page,isExport,sortModel)
      .pipe(takeUntil(this.destroy$)).subscribe((e:any) => {
        this.exportSkusIds.push({id:e.id});
        if (snackbar) {
          snackbar.dismiss();
        }
      });
    }
  }

  setTagFilter(filterModel){
    let tagIds: any[] = [];
       let tags = filterModel.Tags.values;
       tags.forEach((res)=>{
         let index = this.inventoryService.getTags.findIndex((result) => result?.name === res ||  result?.tagId === res);
         if(index !== -1) tagIds.push(this.inventoryService.getTags[index].tagId);
       });
    const filter = {
      Tags: {
        filterType: "number",
        type: "in",
        intValues:tagIds,
      },
    }
    filterModel.Tags= filter.Tags;
}
  exportTrendBySku(filterModel,columnsDef,search,snackbar){
    this.reportsService
      .GetSalesTrendsExport(filterModel, columnsDef, search)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "trend-By-sku-list-download.csv");
      });
  }

  exportOrders(filterModel,columnsDef,search,snackbar,isExport){
    this.priceyardService
      .GetOrdersListExport(filterModel, columnsDef, search,isExport,this.accountName)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "order-list-download.csv");
      });
  }

  exportBySku(filterModel,columnsDef,search,snackbar,isExport,sortModel){
    var userTimezoneOffset = new Date().getTimezoneOffset() * 60000;
    if(!this.dateFilter){
      this.dateFilter = {
        from: new Date(new Date().setDate(new Date().getDate() - 30)),
        to: new Date(),
      };
    }
    const body:any ={
      filterModel,
      dateFrom:  new Date(this.dateFilter.from.setHours(0,0,0,0)-userTimezoneOffset).toISOString(),
      dateTo: new Date(this.dateFilter.to.setHours(23,59,59,59)-userTimezoneOffset).toISOString(),
    }
    if(sortModel?.length){
      body.sortModel = sortModel;
     }   
    this.reportsService
      .bySkuExport(body, columnsDef, search,isExport)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "profit-by-skus-list-download.csv");
      });
  }

  exportByStockHolding(filterModel,columnsDef,search,snackbar,isExport,sortModel){
    const body:any ={
      filterModel,
    }
    if(sortModel?.length){
      body.sortModel = sortModel;
     }   
    this.reportsService
      .GridByAmazonSummaryExport(body, columnsDef, search,isExport)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "stock-Holding-list-download.csv");
      });
  }

  exportByProduct(filterModel,columnsDef,search,snackbar,page,sortModel?,date?,isExport?){
    this.dateFilter$.pipe(takeUntil(this.destroy$)).subscribe((res)=>this.dateFilter=res);
    if(!this.dateFilter){
      this.dateFilter = {
        from: new Date(new Date().setDate(new Date().getDate() - 30)),
        to: new Date(),
      };
    }
    if(this.router.url == "/analytics/overstocked"){
      this.dateFilter = {
        from: date.from,
        to: date.to,
      };
    }
    const body:any={
      filterModel,
      dateFrom:  new Date(this.dateFilter.from.getTime() - (this.dateFilter.from.getTimezoneOffset() * 60000)).toISOString(),
      dateTo: new Date(this.dateFilter.to.getTime() - (this.dateFilter.to.getTimezoneOffset() * 60000)).toISOString(),
    }
     if(sortModel?.length){
      body.sortModel = sortModel;
     } 
    this.reportsService
      .ByProductExport(body, columnsDef, search,page == 'profitByProduct' ?  ['ItemId',this.productGroupbyFilter] : ['ItemId'],isExport)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "profit-by-skus-list-download.csv");
      });
  }

  productListExport(){
    const  search = this.globalSearch;
    const  filterModel = this.gridApi.getFilterModel();
    const columnsDef = this.gridApi.getColumnDefs();
    const snackbar = this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 1000000,
          horizontalPosition: 'center',
          data: {
            title: 'Preparing file for export...',
            action: 'Dismiss',
            type: 'info',
          },
        }
    );
    this.planyardService
    .GetProductListExport(filterModel, columnsDef, search)
    .pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.downloadBlob(e.body, snackbar, "product-list-download.csv");
    });
    
  }

  downloadBlob(blob, snackbar, name = "sku-list-download.csv") {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = name;
    document.body.appendChild(link);
   link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    document.body.removeChild(link);
    if (snackbar) {
      snackbar.dismiss();
    }
  }

  refresh() {
    if (this.gridApi)
      this.gridApi.refreshServerSide({ route: [], purge: true });
  }
  refreshData(): void {
    this.gridApi.refreshServerSide({ route: [], purge: true });
  }
  setFilter(e) {
    const agGridFilter = e.api.getFilterInstance("Active");
    if(agGridFilter){
    agGridFilter.setModel("true");
    agGridFilter.isFilterActive();
    }
  }

  updateFbaType(selectedItem, shipmentType) {
    this.skuArray = [];
    selectedItem.forEach((element) => {
      this.skuArray.push(element.Sku);
    });
    let payload = {
      skus: this.skuArray,
      isOversized: parseInt(shipmentType.value),
      account: selectedItem[0].Account,
    };
    this.inventoryService.updateIsoversized(payload).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.refreshData();
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Type updated Successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
    });
  }

  closePanel() {
    if (this.gridApi) {
      this.gridApi.closeToolPanel();
      this.isOpened = false;
    }
  }

  onRowClicked(e) {
    if (!e.event.ctrlKey && !e.event.shiftKey) {
      this.rowsSelected = this.gridApi.getSelectedNodes();
      if (this.rowsSelected.some((item) => item.rowIndex === e.rowIndex)) {
        this.rowsSelected.forEach((element) => {
          if (element.rowIndex === e.rowIndex) {
            element.setSelected(true);
          } else {
            element.setSelected(false);
          }
        });
      }
    }
  }

  openSidePanel(panelName?: "productBreakdown" | "skuBreakdown" | "singleSku" | "multiSku" | "fbmOrders" | "settlementOrder" | "costToolPanel" | "claimPanel") {
    if (this.gridApi && this.isOpened) {
      this.gridApi.openToolPanel(panelName);
    }
  }

  addItem() {
    this.dialog
      .open(ProductDetailComponent, {
        width: "95%",
        maxWidth: 1152,
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {
        this.gridApi.refreshServerSide({ route: [], purge: true });
      });
  }

  addVendor(data?) {
    this.dialog
      .open(AddVendorDialogComponent, {
        width: "800px",
        data,
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {
      });
  }

  addLocation(data?) {
    this.dialog
      .open(PopupLogisticWhLocationComponent, {
        width: "335px",
        data,
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {});
  }
  // deleteLocation(data?) {
  //   this.dialog
  //     .open(PopupWhLocationDeleteComponent, {
  //       width: "365px",
  //       height: "588px",
  //       data,
  //     })
  //     .afterClosed()
  //     .pipe(filter((e) => e))
  //     .subscribe((e) => {});
  // }

  deleteLocation(params) {
    if (params.data.ItemCount <= 0) {
      this.dialog
        .open(ConfirmDialogComponent, {
          width: "500px",
          data: {
            title: "Delete warehouse location",
            message: `Are you sure you want to delete ${params.data.LocationCode} from this Warehouse?`,
            actions: [
              { text: "Cancel", buttonStyle: "underline" },
              { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
            ],
          },
        })
        .afterClosed()
        .pipe(filter((e) => e === "Confirm"))
        .subscribe((e) => {
          this.logisticService
            .DeleteWhLocation(params.data.locationid)
            .pipe(takeUntil(this.destroy$)).subscribe(() => {
              this.snackBar.openFromComponent(SnackbarComponent, {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: `Warehouse Location Deleted Successfully`,
                  action: 'Dismiss',
                  type: 'info',
                },
              });
              this.refresh();
              this.logisticService.onTriggerSideber(null);
              this.logisticService.objdata = null;
            });
        });
    } else {
      this.dialog
        .open(ConfirmDialogComponent, {
          width: "500px",
          data: {
            title: "Delete warehouse location",
            message: `A location with item can not be deleted.`,
            actions: [
              // { text: "Cancel", buttonStyle: "underline" },
              { text: "Ok", buttonColor: "primary", buttonStyle: "wire" },
            ],
          },
        })
        .afterClosed();
      //.pipe(filter((e) => e === "Confirm"))
      // .subscribe((e) => {});
    }
  }
  LocationSummery(data?) {
    this.dialog
      .open(PopupLocationSummeryComponent, {
        width: "335px",
        data,
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {});
  }
  deleteLocationSummery(params) {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Delete Item From warehouse",
          message: `Are you sure you want to remove this warehouse and its stock?`,
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        const payload = {
          locationSummaryId:params.data.locationSummaryId
        }
        this.logisticService
          .DeleteWhLocationSummery(payload)
          .pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: `Warehouse Location summery Deleted Successfully`,
                action: 'Dismiss',
                type: 'info',
              },
            });

            this.logisticService.onTriggerSideber(this.logisticService.objdata);            
          });
      });
  }



  purchaseBySku() {
    const skuQtyList = this.shipyardService.skusToAddToShipment.map((sku) => {
      const object = {
        skuId: sku.sku.AccountSkuId,
        qty: sku.qty || 1,
      };

      return object;
    });

    const payload: SavePoPlanPayload = {
      planBySku: true,
      skuQtyList,
    };
    this.purchasingService.SavePoPlan(payload).pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.router.navigate(["forecasting/po-plan"], {
        state: { poPlanId: e, planBySku: true },
      });
    });
  }

  purchaseByItem(withQueue = false) {
    if(this.shipyardService.purchasingQueueCount){
      this.purchasingService.GetPurchasingQueue().pipe(takeUntil(this.destroy$)).subscribe(({
        next:(res:any)=>{
          this.shipyardService.purchasingQueue = res;
          const itemQtyList = this.shipyardService.purchasingQueue.filter(res=>res.accountSkuId == 0).map((item) => {
            const object = {
              itemId: item.itemId,
              qty: item.qty || 1,
              skuBreakdown:[]
            };
            return object;
          });
          this.shipyardService.purchasingQueue.filter(res=>res.accountSkuId != 0).map((sku) => {
            const item = itemQtyList.find((e) => e.itemId === sku.itemId);
            if(item){
              item.skuBreakdown.push({
                skuId: sku.accountSkuId,
                qty: sku.qty || 1,
              });
            }
          });
          
          const payload: SavePoPlanPayload = {
            itemQtyList,
          };
          this.purchasingService.SavePoPlan(payload).pipe(takeUntil(this.destroy$)).subscribe((e) => {
            if(withQueue){
              this.getQueueList(e,false);
            } else{
              this.router.navigate(["forecasting/po-plan", e]);
            }   
          });
      
          if (this.mixpanelService) {
            this.mixpanelService.track('Created PO Plan');
          }
        },
        error:(err)=>{
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: err.error?.error[0],
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
        }
      })
    )
  } else{
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: "Please select item from list",
          action: 'Dismiss',
          type: 'error',
        },
      }
    );
  }
  }

  bulkOperations(bulkType, value?, isUpdateInventoryBulk?) {
    const params = [
      {
        name: "account",
        stringValue: this.account[0],
      }
    ];
  
    if (isUpdateInventoryBulk) {
      params.push({
        name: "option",
        stringValue: value,
      });
    }
    this.dialog
      .open(BulkDialogComponent, {
        width: "1100px",
        data: {
          bulkType: bulkType,
          params: params,
        },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {
        if(e){
          if(bulkType === "CreatePlanBySku" && e != "refresh"){
            this.router.navigate(["forecasting/po-plan", e]);
          } else
            this.gridApi.refreshServerSide({ route: [], purge: true });          
        }     
      });
  }

  mapBulkTypeToName(bulkType) {
    switch (bulkType) {
      case "SkuMapping":
        return "SKU Mapping Bulk";
      case "Products":
        return "Update Products Bulk";
      case "Vendors":
        return "Update Vendors Bulk";
      case "AddWLocation":
        return "Update WhLocation Bulk";
      case "AddLocationQty":
        return "Update WhLocation Qty Bulk";
      case "CreateOrders":
        return "Bulk Create Orders";
      case "AddPo":
      return "Bulk Create PO's";
      case "AddOrderShipCost":
       return "Upload Shipping Cost";
      case "AddItemToWLocation":
        return "Update Inventory Bulk"
      case "MyChannelSku":
        return "Upload Skus"
      case "AddWayfairProducts":
        return "Upload Wayfair Skus"
      case "AddOrderShipCostByPo":
        return "Upload Shipping Cost By PoId"
      case "AnalyticsCostDetailsBulk":
       return "Import Custom Cost - by qty"
      case "AnalyticsIsPeriodCostDetails":
       return "Import Custom Cost - by period"
      default:
        return "Update Bulk";
    }
  }

  exportMappings() {
    this.inventoryService.ExportMappings().pipe(takeUntil(this.destroy$)).subscribe((e) => {
      const snackbar = this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 1000000,
            horizontalPosition: 'center',
            data: {
              title: 'Preparing mappings for export...',
              action: 'Dismiss',
              type: 'info',
            },
          }
      );

      this.downloadBlob(e.body, snackbar, "mappings.csv");
    });
  }

  exportUnMappings() {
    this.inventoryService.ExportUnMappings().pipe(takeUntil(this.destroy$)).subscribe((e) => {
      const snackbar = this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 1000000,
            horizontalPosition: 'center',
            data: {
              title: 'Preparing mappings for export...',
              action: 'Dismiss',
              type: 'info',
            },
          }
      );

      this.downloadBlob(e.body, snackbar, "mappings.csv");
    });
  }

  purchaseAll() {
    const filterModel = this.gridApi.getFilterModel();
    const columnsDef = this.gridApi.getColumnDefs();
    this.purchasingService
      .PurchaseAll(
        filterModel,
        columnsDef,
        this.globalSearch,
        this.planyardService.vendorId
      ).pipe(takeUntil(this.destroy$))
      .subscribe((e: number) => {
        this.router.navigate(["forecasting/po-plan", e]);
      });
  }

  recalculate(){
    this.purchasingService.recalculate().pipe(takeUntil(this.destroy$)).subscribe({
      next: (e: number) => {
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title:err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    });
  }

  replenishAll() {
    const filterModel = this.gridApi.getFilterModel();
    const columnsDef = this.gridApi.getColumnDefs();

    filterModel["Restock"] = {
      filter: 0,
      filterType: "number",
      type: "greaterThan",
    };
    const body = {
      filterModel,
      startRow: 0,
      endRow: 1000000,
    };
    
   this.shipyardService
     .GetSkuList(body, columnsDef, this.globalSearch).pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
       const list = e.data.map(item => {
         return {
           sku: item,
           qty: item.ReplenishByCase
         }
       });
       if (list.length > 0) { 
         this.shipyardService.skusToAddToShipment = list;
         this.createShipment();
       } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: "No items to replenish",
            action: 'Dismiss',
            type: 'error',
          },
        });
       }
    })
  }

  saveRequireExpiration(column,sku, value) {
    const payload = [
      {
        sku: sku.Sku,
        account: sku.Account,
        accountSkuId:sku.AccountSkuId,
        fulfillmentType: sku.FulfillmentType,
        otherChanges: [
          {
            boolValue: value,
            name: column,
          },
        ],
      },
    ];
    this.priceyardService.changePriceFactor(payload).pipe(takeUntil(this.destroy$)).subscribe((res) => {     
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Changes saved',
            action: 'Dismiss',
            type: 'success',
          },
        }
    );
    });
  }

  UpdateOrderQtyPrice(event, column): void {
    let payload;
    const data = event.data;
    if (column === "Price") {
      payload = {
        orders : [{
          orderId: data["Orderid"],
          changes: [
            {
              doubleValue: Number(data[column]),
              name: "Price",
            },
          ],
        }]         
      };
    } else if (column == "Qty") {
      payload = {
        orders : [{
          orderId: data["Orderid"],
          changes: [
            {
              decimalValue: Number(data[column]),
              name: "Qty",
            },
          ],
        }]        
      };
    }
    this.planyardService.UpdateOrderQtyPrice(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 9000,
          horizontalPosition: "center",
          data: {
            title: "Changes saved",
            action: "Dismiss",
            type: "success",
          },
        });
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Operation Unsuccessful", please try again.',
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    }
    });
  }

  ActivateRepricer() {
    const selectedRows = this.getSelected();
    this.dialog
      .open(UpdateRepricerComponent, {
        width: "400px",
        data: {
          selectedRows: selectedRows,
          callBackFn: (dialogRef,modelName,pricingOn) => {
            const selectedRows = this.getSelected();
            const skusList = { skus: [] };
            selectedRows.forEach((skuItem) => {      
              skusList.skus.push({
                sku: skuItem.Sku,
                account: skuItem.Account,
                accountSkuId:skuItem.AccountSkuId,
                fulfillmentType: skuItem.FulfillmentType,
                changingFactors: [],
                modelName: modelName,
                pricingOn: pricingOn,
              });
            });
            this.priceyardService.changePriceFactor(skusList.skus).pipe(takeUntil(this.destroy$)).subscribe({
              next: (response) => {
                if (response) {
                  if (dialogRef) dialogRef.close();
                  this.gridApi.refreshServerSide({ route: [], purge: true });
                  this.snackBar.openFromComponent(SnackbarComponent,
                      {
                        duration: 3000,
                        horizontalPosition: 'center',
                        data: {
                          title: 'Changes saved successfully',
                          action: 'Dismiss',
                          type: 'success',
                        },
                      }
                  );
                }
              },
              error: (error) => {
                if (dialogRef) dialogRef.close();
                this.snackBar.openFromComponent(SnackbarComponent,
                  {
                    duration: 3000,
                    horizontalPosition: 'center',
                    data: {
                      title: 'Operation Unsuccessful", please try again.',
                      action: 'Dismiss',
                      type: 'error',
                    },
                  }
                );
              }
              }
            );          
          }
        }        
      })
    .afterClosed();
  }
  
  historyExport(filterModel,columnsDef,search,snackbar,isExport){
    this.logisticService.getAllLocationItemsHistoryExport(filterModel,columnsDef,search,isExport).pipe(takeUntil(this.destroy$)).subscribe((res)=>{      
      this.downloadBlob(res.body, snackbar, "history-download.csv");
    });
  }
  
  addSkuToModel() {
    const dialog = this.dialog.open(AddSkuDialogComponent, {
      width: "700px",
      disableClose: true,
      panelClass: "dialog-container-custom",
      data: {
        confirmationButton: "Confirm",
        isAddSku: true,
        hideQty: true
      },
    });
    dialog.afterClosed().subscribe((res) => {
      if(res) {
        let skus = res.map((e) => e.sku);
        this.priceyardService.UpdateSkuPricingModel(skus,this.account[0],this.priceyardService.modelId).pipe(
          takeUntil(this.destroy$)
        )
        .subscribe((response: Model) => {
          this.gridApi?.refreshServerSide({ route: [], purge: true });
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Sku added successfully',
                action: 'Dismiss',
                type: 'success',
              },
            })
        },(err)=>{
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: err?.error?.error[0],
                action: 'Dismiss',
                type: 'error',
              },
            })
        });
      }      
    });
  }

  editDimensions(event,column){
    this.skuList = [];
    const data = event.data;
    const payload = {
      sku: data["Sku"],
      account: this.account[0],
      otherChanges: [{
        name: column,
        doubleValue: Number(data[column]),
        intValue: 0,
      }]
    };
    this.skuList.push(payload); 
    this.priceyardService.changePriceFactor(this.skuList).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 9000,
            horizontalPosition: 'center',
            data: {
              title: 'Changes saved',
              action: 'Dismiss',
                type: 'success',
            },
          }
        );
      },
    error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Operation Unsuccessful", please try again.',
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    }
   });
  }

  importBulk() {
    this.dialog.open(BulkDialogComponent, {
      width: "1100px",
      data: {
        bulkType: "SkuPrepItemCost",
        params: [
          {
            name: "account",
            stringValue: this.account[0]
          }],
      },
    }).afterClosed()
    .pipe(filter((e) => e === "refresh"))
    .subscribe((e) => {
      this.gridApi.refreshServerSide({ route: [], purge: true });
    });
  }

  editSkuCost(event, column) {
    const data = event.data;
    let skus
    if (column === "SkuPrep" || column == 'SkuCost') {
      skus = {
        sku: data["Sku"],
        SkuPrep: Number(data[column]),
        account: this.account[0],
        fulfillmentType: "Fba",
        changingFactors: [],
        otherChanges: [
          {
            doubleValue: Number(data[column]),
            name: column,
          },
        ],
      };
    }
    this.skuList.push(skus);
    this.priceyardService.changePriceFactor(this.skuList).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          let snackBarRef = this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 5000,
          horizontalPosition: 'center',
          data: {
            title: 'Cost Detail has been updated successfully, please recalcute to get updated data',
            action: 'Recalculate',
            type: 'success',
          },
        }
      );
      snackBarRef.onAction().pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.recalculateCostDetail();
       })
    },
    error: (error) => {   
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Operation Unsuccessful", please try again.',
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
      }
    );
  }

  exportByVendor(filterModel,columnsDef,search,snackbar){
    var userTimezoneOffset = new Date().getTimezoneOffset() * 60000;
    if(!this.dateFilter){
      this.dateFilter = {
        from: new Date(new Date().setDate(new Date().getDate() - 30)),
        to: new Date(),
      };
    }
    const body={
      filterModel,
      dateFrom:  new Date(this.dateFilter.from.setHours(0,0,0,0)-userTimezoneOffset).toISOString(),
      dateTo: new Date(this.dateFilter.to.setHours(23,59,59,59)-userTimezoneOffset).toISOString(),
    }  
    this.reportsService
      .byVendorExport(body, columnsDef, search)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "Po-vendor-list-download.csv");
      });
  }

  exportByItemInventory(filterModel,columnsDef,search,snackbar){
    const body={
      filterModel
    }  
    this.reportsService
      .gridByItemInventoryExport(body, columnsDef, search)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "Item-Inventory-list-download.csv");
      });
  }

  createListing(){
    if(this.accountType=="Walmart"){
      this.createListingWalmart(); 
    } else{
     this.createListingAmazon();
    }
  }
  
  createListingAmazon(){
    this.dialog.open(PublishListingComponent,{
      width: "800px",
     data:{
      title:"Create SKU"
     }
    }).afterClosed()
    .subscribe((e) => {
      if(e === "Create")
      this.gridApi.refreshServerSide({ route: [], purge: true });
    })
  }

  createListingWalmart(){
    this.dialog.open(PublishListingWalmartComponent,{
      width: "800px",
     data:{
      title:"Create SKU"
     }
    }).afterClosed()
    .subscribe((e) => {
      if(e === "Create")
      this.gridApi.refreshServerSide({ route: [], purge: true });
    })
  }

    exportProductList(filterModel,columnsDef,search,snackbar,isExport){
    this.planyardService
    .GetProductListExport(filterModel, columnsDef, search,isExport)
    .pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.downloadBlob(e.body, snackbar, "product-list-download.csv");
    });
  }

  exportShipmentList(filterModel,columnsDef,search,snackbar,isExport){
    this.shipyardService
    .shipmentHeaderListExport(filterModel, columnsDef, search,isExport)
    .subscribe((e) => {
      this.downloadBlob(e.body, snackbar, "shipment-list-download.csv");
    });
  }

  exportWalmartShipmentList(filterModel,columnsDef,search,snackbar,isExport){
    this.walmartService
    .walmartShipmentHeaderListExport(filterModel, columnsDef, search,isExport)
    .subscribe((e) => {
      this.downloadBlob(e.body, snackbar, "shipment-list-download.csv");
    });
  }

  async downloadBlobType(url,name,snackBar){
    const outsideRes =  fetch(await url);
    const blob = (await outsideRes).blob();
    const blobUrl = window.URL.createObjectURL(await blob);
    const link = document.createElement("a");
      link.href = blobUrl;
      link.download = name;
   link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    this.showToaster(snackBar);
  }

  showToaster(snackBar){
    snackBar?.dismiss();
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 5000,
      horizontalPosition: "center",
      data: {
        title: "Labels printed successfully",
        action: "Dismiss",
        type: "success",
      },
    })
  }


  filterModelGridKey(): string {
    let key = '';
    switch (this.router.url) {
      case '/inventory/skus':
        key = StorageKeyEnum.AgGridFilterInventorySkus;
        break;
      default:
        break;
    }
    return key;
  } 

  deleteQueue(page?) {
    this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Clear Qty Input",
        message: `Are you sure you want to clear qty input?`,
        actions: [
          { text: "Cancel", buttonStyle: "underline" },
          { text: "Confirm",  buttonColor: "accent", buttonStyle: "wire" },
        ],
      },
    })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        if(page == 'replenish'){
          this.clearQueuedSkus(true);  
        }else{
          this.getQueueList(null,true);
        }             
      });
  }

  clearQueuedSkus(isClear=false){
    if (this.shipyardService.skusToAddToShipment.length) {
      const accountSkuIds = this.shipyardService.skusToAddToShipment.map((e) => {
        return  e.sku.AccountSkuId;
      })
      const payload={
        accountSkuIds: accountSkuIds
      }
      this.shipyardService.RemoveShipmentQueue(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          this.shipyardService.updateQueueCount.next(true);
          if(isClear){
            this.shipyardService.skusToAddToShipment = [];
            this.gridApi?.deselectAll();
            this.gridApi?.refreshServerSide({ route: [], purge: true });
          }
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Operation Unsuccessful", please try again.',
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
      })
    }
  }
  
  recalculatePriceAction() {
    const estimateFeesRequests = this.shipyardService.skusToAddToShipment.map((item) => {
      return {
        asin: item.sku.Asin,
        itemCost: 5,
        profitMarkupOptions: "markup",
        profitAmount: 0,
        profitMargin: 0,
        profitMarkup: 10,
        isMinMaxUpdate: true,
        fulfillmentType: item.sku.FulfillmentType
      };
    });
    let payload: any = {
      estimateFeesRequests: estimateFeesRequests,
      account: this.account[0]
    }
    this.calculateAmazonPrice(payload, true)
  }

  calculateAmazonPrice(payload, isMinMaxUpdate = false) {
    this.isMinMaxUpdate = isMinMaxUpdate;
    this.priceyardService.ProcessBulkMinandMaxPrice(payload)
    .subscribe((e: any) => {
      this.priceyardService.PriceCalculatorId = e.id;
    },
    (error)=>{
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        horizontalPosition: "center",
        data: {
          title: error?.error?.error[0],
          action: "Dismiss",
          type: "error",
        },
      })
    });
  }
  
  async downloadBlobList(url,name = "sku-list-download.csv",message?) {
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        horizontalPosition: 'center',
        data: {
          title: `${message}` +'preparing download...', 
          action: 'Dismiss',
          type: 'info',
        },
      }
    );
  const outsideRes = await fetch(url.message);
  const blob = (await outsideRes).blob();
  const blobUrl = window.URL.createObjectURL(await blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = name;
   link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    this.snackBar.dismiss();
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: `${message}` + ' downloaded successfully.', 
          action: 'Dismiss',
          type: 'success',
        },
      }
    );
    document.body?.removeChild(link);
  }

  vendorToggleActivate(){
    const selecteRows = this.gridApi.getSelectedRows();
    const itemVendorIds=selecteRows.map(res=>res.ItemVendorId);  
    const payload: any = {
      isDeleted: false,
      vendorItemIdList: itemVendorIds
    }
    this.setVendorItemActivate(payload);
  }

  setVendorItemActivate(payload) {
    this.inventoryService.BulkVendorItemDelete(payload).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Changes saved successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
        ),
        this.gridApi.refreshServerSide({ purge: true });
        this.gridApi.deselectAll();
        (error) => {
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Operation Unsuccessful", please try again.',
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
        }
      }
    })

  }

 vendorToggleDeactivate(){
    const selecteRows = this.gridApi.getSelectedRows();
    let itemVendorIds=selecteRows.map(res=>res.ItemVendorId);    
    const payload:any={
        vendorItemIdList: itemVendorIds
    }
  this.inventoryService.ValidateBulkVendorItemDelete(payload).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
    if(res.invalidItem.length){
      if(res.invalidItem.length != itemVendorIds.length){
        itemVendorIds = itemVendorIds.filter(ar => !res.invalidItem.find(rm => (rm.vendorItemId === ar) ));
        const payload: any = {
          isDeleted: true,
          vendorItemIdList: itemVendorIds
        }
        this.setVendorItemActivate(payload);
      }
      this.openDailog(res);
    } else{
      const payload: any = {
        isDeleted: true,
        vendorItemIdList: itemVendorIds
      }
      this.setVendorItemActivate(payload);
    }
    (error) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Operation Unsuccessful", please try again.',
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    }
  })
 }

 openDailog(data){
    this.dialog.open(VendorTogglePopupComponent,{
      width:"365px",
      data:{
          data:data.invalidItem, 
          actions: [
                { text: "Dimiss", buttonStyle: "underline" },
                { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
               ],
        }
    })
  }

setRecalCulateSignalR(){
  this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy$),
    filter((e) => e.action === "RunSP_recalc_all -1"))
    .subscribe((e) => {
      if(e.response.responseType == 'success'){
        this.snackBarPopup = this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 15000,
            horizontalPosition: 'center',
            data: {
              title: 'Recalculation done, Please reload your page',
              action: 'Dismiss',
              type: 'success',
            },
          }
        );
      }
    })
}
 openCaseDialog(selectedRows){
   selectedRows = selectedRows.filter(row=> !row.CaseCreationDate);
   if(selectedRows.length){
    this.dialog.open(MultipleOpenCaseDialogComponent,{
      width:"900px",
      data:{
          data:selectedRows,
        }
      })
   }
 }
  setTickInterval(series, numPoints, isPosition = false) {
    let maxValue = [];
    let minValue = [];
    series.forEach((res) => {
      let data = res.map((element) => element.data);
      maxValue.push(Math.max(...data));
      minValue.push(Math.min(...data));
    });
    const step = Math.ceil((Math.max(...maxValue) - Math.min(...minValue)) / (numPoints - 1));
    const points: number[] = [];
    for (let i = 0; i < numPoints; i++) {
      points.push(Number((Math.min(...minValue) + step * i).toFixed(2)));
    }
    return isPosition ? points  :  points[1] - points[0];
  }
  
  recalculateCostDetail(){
    this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Recalculate Cost Detail",
        message: `Are you sure you want to recalculate? (this may take a few minutes)`
      },
    })
    .afterClosed()
    .pipe(filter((e) => e === "Confirm"))
    .subscribe((e) => {
      this.inventoryService.recalOrdersYearInsertBm().pipe(takeUntil(this.destroy$)).subscribe({
        next: (e: number) => {},
        error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title:err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
      });     
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  createPO() {
    const skuQtyList = this.shipyardService.skusToAddToShipment.map((sku) => {
      const object = {
        accountSkuId: sku.sku.AccountSkuId,
        quantity: sku.qty || 1,
      };
      return object;
    });
    const payload = {
      account: this.account[0],
      itemList: skuQtyList
    }
    this.shipyardService.createPlanBySku(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if (res) {
          this.router.navigate(["forecasting/po-plan", res]);
          this.clearQueuedSkus(); 
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Changes saved successfully',
                action: 'Dismiss',
                type: 'success',
              },
            }
          ),
          this.gridApi.deselectAll();
        }
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 0,
          horizontalPosition: 'center',
          data: {
            title: err?.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }


  clearPurchasingQueued(isClear=false){
    let removeSku:any[] = [];
    if(this.shipyardService.purchasingQueue?.length){
      this.shipyardService.purchasingQueue.map((el)=>{
        removeSku.push({
          accountSkuId: el.accountSkuId,
          itemId:el.itemId
        })
      })
     }
      
      const payload={
        removeSku: removeSku
      }
      this.purchasingService.RemovePurchasingQueue(payload).pipe(takeUntil(this.destroy$))
      .subscribe({
        next:(res)=>{
          this.purchasingService.updatePurchasingQueueCount.next(true);
          this.shipyardService.skusToAddToShipment = [];
          this.shipyardService.subSkusToAddToShipment = [];
          if(isClear){
            this.gridApi?.deselectAll();
            this.gridApi?.refreshServerSide({ route: [], purge: true });
          }
        },
        error:(err)=>{
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Operation Unsuccessful", please try again.',
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
        }
      }) 
  }

  getQueueList(e?,isClear?){
    this.purchasingService.GetPurchasingQueue().pipe(takeUntil(this.destroy$)).subscribe(({
      next:(res:any)=>{
        this.shipyardService.purchasingQueue = res;
        if(e || isClear){
          this.clearPurchasingQueued(isClear);
          if(!isClear) this.router.navigate(["forecasting/po-plan", e]);
        }        
      },
      error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    }))
  }

  tagsManagement(page,title?){
    this.dialog.open(AssignTagsComponent,{
      width: "700px",
     data:{
      title: title,
      page: page,
      selectedRows:this.gridApi.getSelectedRows()
     }
    }).afterClosed()
    .subscribe((e) => {
      if(e === "Save")
      this.gridApi.refreshServerSide({ route: [], purge: true });
    })
  }

  removeTags(page){
    this.dialog.open(RemoveTagsComponent,{
      width: "700px",
     data:{
      title: "Remove Tags",
      page: page,
     }
    }).afterClosed()
    .subscribe((e) => {
      if(e)
      this.gridApi.refreshServerSide({ route: [], purge: true });
    })
  }

  exportShipment(isHeader=false){
    const payload={
      account:  this.account[0],
      type: this.accountType,
      isHeader:isHeader,
      Statuses:this.selectedStatuses
      }
  this.shipyardService.ExportShipmentListHeaderDetail(payload).subscribe((data:any) => {
    this.shipyardService.exportShipmentEvent.push({id:data.id,isHeader})
  },(err)=>{
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: err.error?.error[0],
          action: 'Dismiss',
          type: 'error',
        },
      });
    }
  )
  }
  updateVendorItemCaseDim(event,column){
    const payload = {
      itemVendorId: event.data.ItemVendorId,
      fieldName: column,
      value: Number(event.newValue)
    }
    this.inventoryService.updateVendorItemCaseDim(payload).subscribe({
      next:(res)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 9000,
            horizontalPosition: 'center',
            data: {
              title: 'Changes saved',
              action: 'Dismiss',
                type: 'success',
            },
          }
        );
      },
      error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }

  getStatus(selectedTab){
    switch (selectedTab) {
      case "all":
        this.isWalmart ?
        this.allStatus = ["DRAFT","PENDING_SHIPMENT_DETAILS","AWAITING_DELIVERY","RECEIVING_IN_PROGRESS","CLOSED", "CANCELLED", "DELETED"] :
        this.allStatus = ["DRAFT","WORKING", "IN_TRANSIT","READY_TO_SHIP","CHECKED_IN","SHIPPED","CHECKED_IN","RECEIVING","CLOSED", "CANCELLED", "DELETED"];
        break;
      case "drafts":
        this.isWalmart ?
        this.selectedStatuses = ["DRAFT"] :
        this.selectedStatuses = ["DRAFT"];
        break;
      case "working":
        this.isWalmart ?
        this.selectedStatuses = ["PENDING_SHIPMENT_DETAILS",] :
        this.selectedStatuses = ["WORKING", "IN_TRANSIT","READY_TO_SHIP","CHECKED_IN","SHIPPED"];
        break; 
        case "receiving":
          this.isWalmart ?
          this.selectedStatuses = ["AWAITING_DELIVERY","RECEIVING_IN_PROGRESS"]:
          this.selectedStatuses = ["SHIPPED","CHECKED_IN","RECEIVING","DELIVERED"];
        break;
      case "closed":
        this.selectedStatuses = ["CLOSED", "CANCELLED", "DELETED"];
        break;
      default:
        selectedTab;
    }
  }

  deductViaSku(){
    this.dialog.open(DeductViaSkuDialogComponent,{
      width: "800px",
     data:{
      title:"Deduct Via Sku"
     }
    }).afterClosed()
    .subscribe((e) => {
      if(e === "Confirm")
      this.gridApi.refreshServerSide({ route: [], purge: true });
    })
  }
  
  exportClaims(filterModel,columnsDef,search,snackbar){
    const body={
      filterModel
    }  
    this.shipmentMonitorService
      .exportClaims(body, columnsDef, search)
      .pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.downloadBlob(e.body, snackbar, "Claim-list-download.csv");
      });
  }

  
  createQuickProducts(){
   const payload = {
    totalCount:this.gridApi.getDisplayedRowCount(),
    filterModel:this.gridApi.getFilterModel(),
    columnsDef:this.gridApi.getColumnDefs(),
    search:this.globalSearch
   }
    this.dialog.open(CreateQuickProductDialogComponent,{
      width: "500px",
      data:payload
    }).afterClosed()
    .subscribe((e) => {
      if(e)
      this.gridApi.refreshServerSide({ route: [], purge: true });
    })
  }

  saveShipment(){
    const skuBreakdown = this.shipyardService.purchasingQueue?.filter((sku)=> sku.accountSkuId != 0).map((res)=>{
      return {
        account:res.account,
        accountSkuId: res.accountSkuId,
        qty: res.qty,
        shipmentTypeId:res.shipmentTypeId,
        sku:res.sku
      }
    })
    const payload = {
      forecastingSaveDraftShipmentDto:skuBreakdown
    }
    this.shipyardService.forecastingSaveDraftShipment(payload).subscribe({
     next:(res)=>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'ShipmentDraft has been created successfully',
            action: 'Dismiss',
            type: 'success',
          },
        }
      );
    },error:(err)=>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
      }
    })
  }

}
